// reducer.js
import * as actionTypes from "./actionsTypes"

const initialState = {
  currentPage: 0,
  pageSize: 20,
  customFilters: [],
  value: "",
  sortField: "cut_off_date",
  sortOrder: "desc",
  sorting: [],
  activeTab: "details",
  pageHmHistorique: 0,
  pageHmPaiement: 0,
  idFxFacturationAccount: "",
  column: [],
  //
  //Nouveau
  query: "",
  actif: {},
  selectedOptionFilters: null,
  selectedOptionId: null,
}

const FiltreFxFacturation = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_FX_FACTURATION:
      return {
        ...state,
        value: action.payload,
      }
    case actionTypes.SET_CURRENT_PAGE_FX_FACTURATION:
      return {
        ...state,
        currentPage: action.payload,
      }
    case actionTypes.SET_CUSTOM_FILTERS_FX_FACTURATION:
      return {
        ...state,
        customFilters: action.payload,
      }
    case actionTypes.SET_SORT_FIELD_FX_FACTURATION:
      return {
        ...state,
        sortField: action.payload,
      }
    case actionTypes.SET_SORTING_FX_FACTURATION:
      return {
        ...state,
        sorting: action.payload,
      }
    case actionTypes.SET_PAGE_SIZE_FX_FACTURATION:
      return {
        ...state,
        pageSize: action.payload,
      }
    case actionTypes.SET_ORDER_FX_FACTURATION:
      return {
        ...state,
        sortOrder: action.payload,
      }
    case actionTypes.SET_CUSTOM_FILTERS_FX_FACTURATION:
      return {
        ...state,
        customFilters: action.payload,
      }
    case actionTypes.SET_ACTIVE_TAB_FX_FACTURATION:
      return {
        ...state,
        activeTab: action.payload,
      }
    case actionTypes.SET_PAGE_HISTORIQUE_HM_FX_FACTURATION:
      return {
        ...state,
        pageHmHistorique: action.payload,
      }
    case actionTypes.SET_PAGE_PAIEMENT_HM_FX_FACTURATION:
      return {
        ...state,
        pageHmPaiement: action.payload,
      }
    case actionTypes.SET_ID_FX_FACTURATION:
      return {
        ...state,
        idFxFacturationAccount: action.payload,
      }
    case actionTypes.SET_COLUMN_FX_FACTURATION:
      return {
        ...state,
        column: action.payload,
      }
    case actionTypes.SET_QUERY_FX_FACTURATION:
      return {
        ...state,
        query: action.payload,
      }
    case actionTypes.SET_ACTIF_FX_FACTURATION:
      return {
        ...state,
        actif: action.payload,
      }
    case actionTypes.SET_SELECTED_OPTION_FILTERS_FX_FACTURATION:
      return {
        ...state,
        selectedOptionFilters: action.payload,
      }
    case actionTypes.SET_SELECTED_OPTION_ID_FX_FACTURATION:
      return {
        ...state,
        selectedOptionId: action.payload,
      }
    default:
      return state
  }
}

export default FiltreFxFacturation
